import qs from 'qs';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';

export interface PDFTimeZone {
  timezone?: string;
}

export const downloadConversation = async (sid: string, payload?: PDFTimeZone, userRole?: string): Promise<string> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.get(
    `${prefix}/conversations/${sid}/download?${qs.stringify(payload, { skipNulls: true })}`,
  );

  return data;
};
